import { useEffect } from 'react';
import { tr } from '@/i18n/copy';
import { toast } from 'sonner';

export default function useClientNavigationGuard({dirty, busy}) {
  useEffect(() => {
    const leave = event => {
      if (busy) {
        event.preventDefault();
        toast.info(tr('Attendi il completamento del salvataggio.'));
      } else if (dirty && !window.confirm(tr('Ci sono modifiche non salvate. Vuoi lasciarle e cambiare sezione?'))) {
        event.preventDefault();
      }
    };
    window.addEventListener('tps:client-navigate', leave);
    return () => window.removeEventListener('tps:client-navigate', leave);
  }, [dirty, busy]);
}
